import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";

/**
 * 新しいバージョンのアプリが見つかった場合にページをリロードする
 *
 * Service Workerの更新を検知し、新しいバージョンが待機状態になったら
 * skipWaitingを実行してアクティブ化し、ページをリロードする
 */
export const useReloadIfNewVersionFound = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp3, t0);
};
function _temp() {
  if (process.env.NODE_ENV === "test") {
    return;
  }
  window.location.reload();
}
function _temp2(worker) {
  if (!worker) {
    return;
  }
  worker.postMessage({
    type: "SKIP_WAITING"
  });
}
function _temp3() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator) || !navigator.serviceWorker) {
    return;
  }
  let updateIntervalId = null;
  const handleControllerChange = _temp;
  const activateWaitingWorker = _temp2;
  const registerServiceWorkerListeners = async () => {
    ;
    try {
      const registration = await navigator.serviceWorker.ready;
      const safeUpdate = async trigger => {
        ;
        try {
          await registration.update();
        } catch (t1) {
          const error_0 = t1;
          console.error(`[SW] registration.update failed (${trigger}):`, error_0);
        }
      };
      if (registration.waiting) {
        activateWaitingWorker(registration.waiting);
      }
      registration.addEventListener("updatefound", () => {
        const newWorker = registration.installing;
        if (!newWorker) {
          return;
        }
        newWorker.addEventListener("statechange", () => {
          if (newWorker.state === "installed" && navigator.serviceWorker.controller) {
            const waitingWorker = registration.waiting ?? newWorker;
            activateWaitingWorker(waitingWorker);
          }
        });
      });
      await safeUpdate("initial");
      updateIntervalId = setInterval(() => {
        safeUpdate("interval");
      }, 600000);
      navigator.serviceWorker.addEventListener("controllerchange", handleControllerChange);
    } catch (t0) {
      const error = t0;
      console.error("[SW] Error:", error);
    }
  };
  registerServiceWorkerListeners();
  return () => {
    if (updateIntervalId) {
      clearInterval(updateIntervalId);
    }
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.removeEventListener("controllerchange", handleControllerChange);
    }
  };
}